/* eslint-disable max-len */
export const GET_SUPPORTED_RELIGIONS_LIST = 'SUPPORTED_RELIGIONS/GET_SUPPORTED_RELIGIONS_LIST'
export const GET_SUPPORTED_RELIGIONS_LIST_SUCCESS = 'SUPPORTED_RELIGIONS/GET_SUPPORTED_RELIGIONS_LIST_SUCCESS'
export const GET_SUPPORTED_RELIGIONS_LIST_FAILED = 'SUPPORTED_RELIGIONS/GET_SUPPORTED_RELIGIONS_LIST_FAILED'

export const GET_SUPPORTED_RELIGIONS_DROPDOWN_LIST = 'SUPPORTED_RELIGIONS/GET_SUPPORTED_RELIGIONS_DROPDOWN_LIST'
export const GET_SUPPORTED_RELIGIONS_DROPDOWN_LIST_SUCCESS = 'SUPPORTED_RELIGIONS/GET_SUPPORTED_RELIGIONS_DROPDOWN_LIST_SUCCESS'
export const GET_SUPPORTED_RELIGIONS_DROPDOWN_LIST_FAILED = 'SUPPORTED_RELIGIONS/GET_SUPPORTED_RELIGIONS_DROPDOWN_LIST_FAILED'

export const CLEAR_SUPPORTED_RELIGIONS_LIST = 'SUPPORTED_RELIGIONS/CLEAR_SUPPORTED_RELIGIONS_LIST'
